/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import Helper from "../helper";
import AppSettings from "../settings";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import "../css/home.css";
import magnifierImg from "../img/magnifier.svg";
import noImage from "../img/agua01.jpg";

export default class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      regionId: AppSettings.defaultTipoInforme,
      newsItems: [],
    };
  }

  render() {
    return (
      <div>
        <TapaCarousel />
        <section className="u-align-left u-clearfix u-custom-color-1 u-section-2">
          <div className="u-clearfix u-sheet u-sheet-1">
            <div className="u-expanded-width u-tab-links-align-justify u-tabs u-tabs-1">
              <InformeSelector
                changeRegionHandler={(ev) => this.handleChangeRegion(ev)}
                selectedRegion={this.state.regionId}
              />
              <NewsContainer
                items={this.state.newsItems}
                changePageHandler={this.props.changePageHandler}
              />
            </div>
          </div>
        </section>
      </div>
    );
  }

  componentDidMount() {
    this.getNews(this.state.regionId);
  }

  handleChangeRegion(ev) {
    this.getNews(ev.tipo_informe_id);
  }

  getNews(regionId) {
    const region = regionId;
    const apiUrl =
      AppSettings.apiUrlInformeLatestNews +
      "&filter[tipo_informe_id][_eq]=" +
      region;
    const fechaInforme =
      AppSettings.apiUrlInformeLatestFecha +
      "&filter[tipo_informe_id][_eq]=" +
      region;
    fetch(apiUrl).then(
      (res) => {
        res.json().then((jsres) => {
          Helper.checkItemsApiResponse(jsres);
          let res = jsres.data[0].noticias;
          res.sort(this.compareNews);
          let data = [];

          for (var i in res) {
            data.push(res[i].noticias_noticia_id);
          }

          this.setState({
            regionId: region,
            newsItems: data,
          });
        });
      },
      (error) => {
        console.log(error);
      }
    );
    fetch(fechaInforme).then((res) => {
      res.json().then((jsres) => {
        Helper.checkItemsApiResponse(jsres);
        let informeFecha = jsres.data[0].fecha;
        // console.log(informeFecha)
      });
    });
  }

  compareNews(a, b) {
    var result = b.orden - a.orden;

    if (result < 0) {
      return 1;
    } else if (result > 0) {
      return -1;
    } else {
      return 0;
    }
  }
}

class TapaCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isViewing: null,
      items: [],
      currentIndex: 0,
      zoomPosition: { x: 0, y: 0 },
    };
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    const apiUrl = AppSettings.apiUrlInformeLatestTapas;

    fetch(apiUrl).then(
      (res) => {
        res.json().then((jsres) => {
          Helper.checkItemsApiResponse(jsres);
          let data = jsres.data[0].tapas;
          this.setState({
            isLoaded: true,
            items: data,
          });
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  handleImageClick = (tapa, index) => {
    const imageSrcFull = Helper.getImageUrl(tapa, false); // URL completa
    this.setState({
      isViewing: imageSrcFull,
      isModalOpen: true,
      currentIndex: index,
    });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleMouseMove = (e) => {
    if (!this.imageRef.current) return;

    const { left, top, width, height } =
      this.imageRef.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    this.setState({ zoomPosition: { x, y } });
  };

  handleNext = () => {
    const { currentIndex, items } = this.state;
    const nextIndex = (currentIndex + 1) % items.length;
    const nextImage = Helper.getImageUrl(items[nextIndex].tapa, false);
    this.setState({
      currentIndex: nextIndex,
      isViewing: nextImage,
    });
  };

  handlePrev = () => {
    const { currentIndex, items } = this.state;
    const prevIndex = (currentIndex - 1 + items.length) % items.length;
    const prevImage = Helper.getImageUrl(items[prevIndex].tapa, false);
    this.setState({
      currentIndex: prevIndex,
      isViewing: prevImage,
    });
  };

  render() {
    if (this.state.isLoaded) {
      const { items, isViewing, isModalOpen, zoomPosition } = this.state;

      const tapasDOM = items.map((val, index) => {
        const imageSrcPreview = Helper.getImageUrl(val.tapa, true);
        return (
          <SwiperSlide
            key={val.tapa}
            onClick={() => this.handleImageClick(val.tapa, index)}
          >
            <img alt="" src={imageSrcPreview} width="100px" />
          </SwiperSlide>
        );
      });

      return (
        <div>
          <Swiper
            slidesPerView={AppSettings.swiper.small.slidesPerView}
            slidesPerGroup={AppSettings.swiper.small.slidesPerGroup}
            spaceBetween={AppSettings.swiper.small.spaceBetween}
            breakpoints={{
              1350: AppSettings.swiper.desktop,
              900: AppSettings.swiper.smalldesktop,
              700: AppSettings.swiper.tablet,
              400: AppSettings.swiper.mobile,
            }}
            loop={AppSettings.swiper.loop}
            navigation={true}
            modules={[Navigation]}
            className="home-tapa-carousel-swiper"
          >
            {tapasDOM}
          </Swiper>

          {isModalOpen && (
            <div className="modal-overlay" onClick={this.closeModal}>
              <div
                className="modal-content"
                onClick={(event) => event.stopPropagation()}
              >
                <button className="prev" onClick={this.handlePrev}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#0055a6"
                    className="svg-icon-arrow"
                  >
                    <path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z" />
                  </svg>
                </button>
                {isViewing && (
                  <div
                    className="zoom-container"
                    onMouseMove={this.handleMouseMove}
                    onMouseLeave={() =>
                      this.setState({ zoomPosition: { x: 0, y: 0 } })
                    }
                  >
                    <img
                      alt=""
                      src={isViewing}
                      ref={this.imageRef}
                      className="modal-image zoom-image"
                      style={{
                        transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
                      }}
                    />
                  </div>
                )}
                <button className="next" onClick={this.handleNext}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#0055a6"
                    className="svg-icon-arrow"
                  >
                    <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                  </svg>
                </button>
                <button className="close" onClick={this.closeModal}>
                  ✖
                </button>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <section className="u-align-center u-clearfix u-white u-section-1"></section>
      );
    }
  }
}

class InformeSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      items: [],
    };
  }

  async componentDidMount() {
    try {
      const apiUrl = AppSettings.apiUrlTipoInforme;
      const res = await fetch(apiUrl);
      const jsres = await res.json();

      Helper.checkItemsApiResponse(jsres);

      const data = jsres.data;
      let news = [];
      for (const dato of data) {
        let noticias = await this.getNews(dato.tipo_informe_id);
        news.push({
          nombre: dato.nombre,
          orden: dato.orden,
          tipo_informe_id: dato.tipo_informe_id,
          content: noticias === undefined ? false : true,
        });
      }

      this.setState({
        isLoaded: true,
        items: news,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async getNews(regionId) {
    try {
      const region = regionId;
      const apiUrl = `${AppSettings.apiUrlInformeLatestNews}&filter[tipo_informe_id][_eq]=${region}`;
      const response = await fetch(apiUrl);
      const jsres = await response.json();

      Helper.checkItemsApiResponse(jsres);
      let noticias = jsres.data[0].noticias;
      return noticias;
    } catch (error) {
      console.warn(error);
    }
  }

  render() {
    if (this.state.isLoaded) {
      const items = this.state.items;
      const selectedStyle = "active";

      const informeSelectorDOM = items.map((val, index) => {
        let selected = "";
        let newindex = index++;
        if (val.tipo_informe_id === this.props.selectedRegion) {
          selected = selectedStyle;
        }

        return (
          <li
            key={`informe-${val.id}-${newindex}`}
            className="u-tab-item u-tab-item-1"
            style={{ display: val.content === false ? "none" : "block" }}
          >
            <a
              onClick={() => this.props.changeRegionHandler(val)}
              className={
                selected +
                " u-active-custom-color-2 u-button-style u-custom-font u-heading-font u-tab-link u-text-grey-90 u-tab-link-1"
              }
              style={{ cursor: "pointer" }}
            >
              {val.nombre}
            </a>
          </li>
        );
      });

      return (
        <div className="InformeSelectorContainer">
          <ol className="u-spacing-30 u-tab-list u-unstyled u-white u-tab-list-1">
            {informeSelectorDOM}
          </ol>
        </div>
      );
    } else {
      return (
        <div className="InformeSelectorContainer">
          <img
            alt={""}
            src={Helper.getImageUrl(AppSettings.loadingImageId, false)}
          />
        </div>
      );
    }
  }
}

class NewsContainer extends React.Component {
  render() {
    if (this.props.items !== undefined) {
      const items = this.props.items;

      const newsDOM = items.map((val, index) => {
        return (
          <News
            key={`new-${val.id}-${index}`}
            item={val}
            changePageHandler={this.props.changePageHandler}
          />
        );
      });

      return (
        <div className="u-tab-content">
          <div className="u-container-style u-tab-active u-tab-pane">
            <div className="u-container-layout u-container-layout-1">
              <div className="u-expanded-width u-list u-list-1">
                <div className="u-repeater u-repeater-1">{newsDOM}</div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div className="NewsContainer"></div>;
    }
  }
}

class News extends React.Component {
  render() {
    var item = this.props.item;

    const ImageVideoAudio = function () {
      const [srcUrl, setSrcUrl] = useState("");
      const [isVideo, setIsVideo] = useState(false);

      const ctaImage = async function () {
        const srcImage = Helper.getImageUrl(item.imagen_principal, true);
        setSrcUrl(srcImage);
      };

      const ctaVideoAudio = async function () {
        const srcVideoAudio = item.media_url;
        if (srcVideoAudio.includes(".mp3")) {
          setSrcUrl("/sound-waves.png");
        } else {
          setSrcUrl(srcVideoAudio);
          setIsVideo(true);
        }
      };

      const defultImage = function () {
        setSrcUrl(noImage);
      };

      // console.log(item)

      useEffect(() => {
        if (item.imagen_principal != null) {
          ctaImage();
        } else if (item.media_url != null) {
          ctaVideoAudio();
        } else {
          defultImage();
        }

        return () => {
          setIsVideo(false);
        };
      }, []);

      return (
        <>
          {isVideo ? (
            <video style={{ objectFit: "fill" }}>
              <source src={srcUrl} type="video/mp4" />
              Tu navegador no soporta el elemento de video.
            </video>
          ) : (
            <img
              alt=""
              className="nota__home-img"
              src={srcUrl}
              data-src={srcUrl}
            ></img>
          )}
        </>
      );
    };

    return (
      <div class="card">
        <div class="cardInfo">
          {/* FUENTE DE LA NOTICIA*/}
          <h1 className="FuenteNota"> {item.fuente}</h1>

          <div class="cardHeader">
            {/* IMAGEN, VIDEO O AUDIO DE LA NOTICIA */}
            <a href={"nota/" + item.noticia_id} style={{ cursor: "pointer" }}>
              <ImageVideoAudio />
            </a>
          </div>

          <div className="TipoFechaNota">
            {/* TIPO DE NOTICIA */}
            <div className="TipoNota">
              {" "}
              {item.tema_noticia_id != null
                ? item.tema_noticia_id.nombre
                : "\u00A0"}
            </div>
            {/* FECHA DE LA NOTICIA*/}
            <div className="FechaNota">
              {" "}
              {new Date(item.fecha).toLocaleDateString(
                AppSettings.defaultLocale,
                { month: "long", day: "numeric" }
              )}
            </div>
          </div>

          {/* TITULO DE LA NOTICIA*/}
          <a href={"nota/" + item.noticia_id}>
            <h2 className="TituNota" style={{ cursor: "pointer" }}>
              {item.titulo}
            </h2>
          </a>
          {/* NOTA RESALTADA DE LA NOTICIA*/}
          <a
            onClick={() =>
              this.props.changePageHandler({
                page: AppSettings.pages.news,
                newsId: item.noticia_id,
              })
            }
          >
            <h3
              className="NotaDest"
              dangerouslySetInnerHTML={{ __html: item.nota_resaltada }}
            ></h3>
          </a>
          {/* BOTON VER MAS: DETALLE DE LA NOTICIA*/}
        </div>
        {/* BOTON VER MÁS*/}
        <div class="cardFooter">
          <a href={"nota/" + item.noticia_id} class="buttonlearn-more">
            <div class="textlearn-more">Ver más</div>
          </a>
        </div>
      </div>
    );
  }
}
